import ReactGA from 'react-ga4';

export default function sendSettingsClickEvent(name: string) {
   ReactGA.event({
      category: 'click',
      action: 'Settings Click - ' + name
   });
}